export function MYOBCompanyFileCtrl (
  $scope,
  $translate,
  $uibModalInstance,
  $window,
  API,
  messages,
  settings,
  workshopAPI
) {
  $scope.credentials = {
    username: 'Administrator',
    password: ''
  };

  $scope.settings = settings;

  $scope.companies = [];
  $scope.selectedCompany;

  $scope.tableSettings = {
    columns: [
      {
        field : 'Name',
        header: {
          text: $translate.instant('COMPANY_SPACE.COMPANY')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PAYMENTS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.back = function () {
    $('.modal-content').removeClass('flip');
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.authorize = function () {
    $window.location.assign(`${API.url}/myob/new`);
  };

  $scope.getCompanyFiles = function () {
    return workshopAPI.get('/myob/company_files');
  };

  $scope.onRowClick = function ( event ) {
    $scope.selectedCompany = event.row.selected
    ? event.row
    : null;
  };

  $scope.select = function () {
    $uibModalInstance.close($scope.selectedCompany);
  };

  $scope.login = function () {
    $scope.processing = true;
    workshopAPI.post('/myob/generate_token', $scope.credentials)
    .then($scope.getCompanyFiles).then(function (companies) {
      $scope.companies = companies;
      $('.modal-content').addClass('flip');
    }, function (err) {
      messages.error(err);
    }).finally(function () {
      $scope.processing = false;
    });
  };
}